/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
 */
export interface CreateRecordingEnvelopePayloadRecordingDupIsrcsInner {
    /**
     * ISRCs (all in `recording.isrcs`) being reassigned from this recording
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
     */
    isrcs: Array<string>;
    /**
     * Recording ID the ISRCs are being reassigned from
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
     */
    dupRecordingId: string;
    /**
     * OpenSearch document ID of the source recording
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecordingDupIsrcsInner
     */
    dupDocumentId: string;
}

/**
 * Check if a given object implements the CreateRecordingEnvelopePayloadRecordingDupIsrcsInner interface.
 */
export function instanceOfCreateRecordingEnvelopePayloadRecordingDupIsrcsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isrcs" in value;
    isInstance = isInstance && "dupRecordingId" in value;
    isInstance = isInstance && "dupDocumentId" in value;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSON(json: any): CreateRecordingEnvelopePayloadRecordingDupIsrcsInner {
    return CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayloadRecordingDupIsrcsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isrcs': json['isrcs'],
        'dupRecordingId': json['dup_recording_id'],
        'dupDocumentId': json['dup_document_id'],
    };
}

export function CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerToJSON(value?: CreateRecordingEnvelopePayloadRecordingDupIsrcsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isrcs': value.isrcs,
        'dup_recording_id': value.dupRecordingId,
        'dup_document_id': value.dupDocumentId,
    };
}

